import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_ADMIN_CUSTOMERS_AND_ORDERS = `${URL_APP_ADMIN}/customers-and-orders`

const URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD = `${URL_ADMIN_CUSTOMERS_AND_ORDERS}/dashboard`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_CX_ADMIN = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD}/admin/customers`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_WILDCARD = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD}/*`

const URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE = `${URL_ADMIN_CUSTOMERS_AND_ORDERS}/care`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE}/customers/:customerId`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_ORDERS_LIST = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_DETAILS}/orders`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_ORDER_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_ORDERS_LIST}/:orderId`
// @hygen:inject admin-urls

export type DashRouteSet = DashRouteType<
  | 'app-admin-customers-and-orders'
  | 'app-admin-customers-and-orders-dashboard'
  | 'app-admin-customers-and-orders-dashboard-cx-admin'
  | 'app-admin-customers-and-orders-dashboard-wildcard'
  | 'app-admin-customers-and-orders-care-customer-details'
  | 'app-admin-customers-and-orders-care-customer-orders-list'
  | 'app-admin-customers-and-orders-care-customer-order-details'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-customers-and-orders': URL_ADMIN_CUSTOMERS_AND_ORDERS,
  'app-admin-customers-and-orders-dashboard': URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD,
  'app-admin-customers-and-orders-dashboard-cx-admin':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_CX_ADMIN,
  'app-admin-customers-and-orders-dashboard-wildcard':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_WILDCARD,
  'app-admin-customers-and-orders-care-customer-details':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_DETAILS,
  'app-admin-customers-and-orders-care-customer-orders-list':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_ORDERS_LIST,
  'app-admin-customers-and-orders-care-customer-order-details':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_CARE_CUSTOMER_ORDER_DETAILS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
